import { t } from "@/lib/i18n";
const Footer = () => (
  <footer className="border-t border-[#E8ECEA] mt-24">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-sm text-[#5C6661]">
      <div className="flex items-center gap-2">
        <span
          className="inline-block w-2 h-2 rounded-full"
          style={{ background: "#2F524A" }}
        />
        <span className="font-serif text-base text-[#1C201F]">
          {t("Radon Action & Tracking")}
        </span>
      </div>
      <p className="max-w-xl">
        {t("Estimated scores are for educational guidance only. A certified short-term test kit is the only way to confirm radon levels in your home.")}
      </p>
    </div>
  </footer>
);

export default Footer;
